import { String, Number, Record, Static, Object } from '@sinclair/typebox';

import { PriceItem } from './associationsMatrix';

export type FlightFare = Static<typeof FlightFare>;
export const FlightFare = Object({
  price: Record(String(), PriceItem),
  availableSeats: Number(),
});

export type FaresMap = Static<typeof FaresMap>;
export const FaresMap = Record(String(), FlightFare);

export type CalendarFaresMap = Static<typeof CalendarFaresMap>;
export const CalendarFaresMap = Record(
  String(),
  Object({
    date: String(),
    price: Number(),
    availableSeats: Number(),
  })
);
